import { NewsActionsEnum } from '../enums/NewsActionsEnum';
import { INewsState } from '../interfaces/INewsState';
import { NewsAction } from '../types/NewsAction';

const initialState: INewsState = {};

export function newsReducer(state = initialState, action: NewsAction): INewsState {
  switch (action.type) {
    case NewsActionsEnum.NEWS_SET_DATA: {
      const { data, type } = action.payload;
      const newState = {
        ...state,
        [type]: {
          data,
        },
      };
      return newState;
    }
    default:
      return state;
  }
}
